module.exports = __webpack_public_path__ + "static/icon_gosuGamers-44fbb4cbc0a829a033bb38139c127a0b.png";